import WizardHeader from './WizardHeader';
import WizardProgress from './WizardProgress';

import type * as React from 'react';

interface IWizardContainerProps {
  step: number;
  onBack?: () => void;
  children: React.ReactNode;
}

const WizardContainer = ({ step, onBack, children }: IWizardContainerProps) => {
  return (
    <div className="max-w-140 flex w-full flex-col items-center justify-center gap-2">
      <div className="bg-primary shadow-xs rounded-4xl flex w-full flex-col gap-2 p-8">
        <WizardHeader onBack={onBack} />
        {children}
      </div>
      <WizardProgress step={step} />
    </div>
  );
};

export default WizardContainer;
